import Link from "next/link"
import { internationalLandingPath } from "@/lib/marketing-locale"

type HomeLanguageSwitcherProps = {
  className?: string
}

export function HomeLanguageSwitcher({ className }: HomeLanguageSwitcherProps) {
  return (
    <nav
      className={`inline-flex items-center gap-0.5 rounded-full border border-gray-200 bg-white/90 p-0.5 text-xs font-semibold shadow-sm ${className ?? ""}`}
      aria-label="Language"
    >
      <Link
        href={internationalLandingPath("en")}
        className="rounded-full px-2.5 py-1 text-gray-600 transition-colors hover:bg-[#01ADEF]/10 hover:text-[#01ADEF]"
      >
        EN
      </Link>
      <Link
        href={internationalLandingPath("hy")}
        className="rounded-full px-2.5 py-1 text-gray-600 transition-colors hover:bg-[#01ADEF]/10 hover:text-[#01ADEF]"
      >
        HY
      </Link>
      <span
        className="rounded-full bg-[#01ADEF]/10 px-2.5 py-1 text-[#01ADEF]"
        aria-current="true"
      >
        FA
      </span>
    </nav>
  )
}
